import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');
export const getPreviousStates = createSelector(
  getPortalState,
  ({ configs }) => configs.previousStates,
);

export const getGrouping = createSelector(
  getPortalState,
  ({ configs }) => configs.currentGrouping,
);
